export default class C5MeioPagamentoModel {
  public meioPagamentoId: string = "";
  public tipo: string = "";
  public gatewayId: string = "";
  public identificador: string = "";

  public static toModel(i: any): C5MeioPagamentoModel[] | null {
    if (i.Type === "CRD" || i.Type === "DEB") {
      return i.Payments.map((p: any) => {
        return {
          tipo: i.Type,
          gatewayId: p.GatewayId,
          identificador: p.NameIdentifier,
          meioPagamentoId: p.PaymentId,
        } as C5MeioPagamentoModel;
      });
    } else {
      return null;
    }
  }
}
